export const viewTitle = (state) => {
  return state.viewTitle
}

export const menuList = (state) => {
  return state.menuList
}

export const expandBanner = (state) => {
  return state.expandBanner
}

export const currentKinoId = (state) => {
  return state.currentKinoId
}

export const summaryMessage = (state) => {
  if (state.summaryMessage.message) {
    return `${state.summaryMessage.message.messageCd} ${state.summaryMessage.message.message}`
  }
  return ''
}

export const messageIcon = (state) => {
  if (state.summaryMessage.message) {
    return state.summaryMessage.message.messageKbn
  }
  return ''
}

export const notificationCount = (state) => {
  return state.notificationCount
}

export const adminNotificationCount = (state) => {
  return state.adminNotificationCount
}

export const systemNotificationCount = (state) => {
  return state.systemNotificationCount
}

export const carNotificationCount = (state) => {
  return state.carNotificationCount
}

export const licenceNotificationCount = (state) => {
  return state.licenceNotificationCount
}
